import { makeJsonRestApiRequest } from '~src/httpClient/RestApiService';

import { IIdentityPool } from '../../types/identityPools/IIdentityPool';

export interface ListIdentityPoolsParams {
}

export interface ListIdentityPoolsResult {
  error?: unknown;
  identityPools?: IIdentityPool[];
}

export function callListIdentityPools(): Promise<ListIdentityPoolsResult> {
  return makeJsonRestApiRequest<ListIdentityPoolsParams, ListIdentityPoolsResult>({
    config: {
        restApiVersion: '3.16',
        httpMethod: 'GET',
        endpoint: 'authn-service/identity-pools',
        serverWideRequest: true
    },
    request: {},
  });
}